/**
 * Origine d'une reprise dans une prévisualisation de modèle.
 *
 * Une reprise n'a pas de programme à elle : elle rejoue celui de son origine.
 * Trois liens y mènent, du plus fort au plus faible — le bloc encore à créer,
 * la reprise miroir arbitrée dans la même passe, et enfin le créneau suivi dont
 * l'arbitrage vient *après* elle (un tapis de nuit qui suit le créneau du soir
 * même). Substituer le programme de l'origine doit donc se répercuter ici.
 */
export function substitutionOriginId(proposal: {
  pendingPremiereReplayOf?: string | null
  mirrorOfProposalId?: string | null
  substitutionOriginProposalId?: string | null
}): string | null {
  return proposal.pendingPremiereReplayOf
    ?? proposal.mirrorOfProposalId
    ?? proposal.substitutionOriginProposalId
    ?? null
}
